
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10.5 5h9a1.5 1.5 0 010 3h-9a1.5 1.5 0 010-3zm0 5h9a1.5 1.5 0 010 3h-9a1.5 1.5 0 010-3zm0 5h9a1.5 1.5 0 010 3h-9a1.5 1.5 0 010-3z"}}),_c('path',{attrs:{"d":"M5.5 8a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","opacity":".3"}})])])
          )
        }
      }
    